import * as styles from "./SectionTextOnlySignpostCard.module.scss";

import React from "react";
import { Button } from "../../../components/common";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionTextOnlySignpostCardProps {
	heading: string;
	htmlText?: string;
	linkUrl?: string;
	linkTitle?: string;
	footerText: string;
	jumpLinksTitle?: string;
}
export const getSectionTextOnlySignpostCardProps = ({
	field_front_end_title,
	field_section_short_description,
	field_link,
	field_section_footer_text,
	field_jump_links_title,
}: Queries.SectionDataFragment): SectionTextOnlySignpostCardProps => ({
	heading: field_front_end_title,
	htmlText: field_section_short_description?.processed,
	linkUrl: field_link?.uri,
	linkTitle: field_link?.title,
	footerText: field_section_footer_text?.value,
	jumpLinksTitle: field_jump_links_title,
});
export const SectionTextOnlySignpostCard: React.FC<
	SectionTextOnlySignpostCardProps
> = ({ heading, htmlText, linkUrl, linkTitle, footerText, jumpLinksTitle }) => {
	return (
		<WrappedSection sectionName="SectionTextOnlySignpostCard">
			<div className={styles.sectiontextonlysignpostcard}>
				<div className={htmlText ? styles.container : styles.containerstacked}>
					<div className={styles.titlewrapper}>
						{jumpLinksTitle ? (
							<h2 className={styles.title} data-jumplinkstitle={jumpLinksTitle}>
								{heading}
							</h2>
						) : (
							<h2 className={styles.title}>{heading}</h2>
						)}
					</div>
					<div className={styles.body}>
						{!!htmlText && (
							<div
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
								dangerouslySetInnerHTML={{
									__html: htmlText,
								}}
							/>
						)}
						<Button
							variant={htmlText ? "secondary" : "primary"}
							fullWidth={false}
							url={linkUrl}
							size={"small"}
						>
							{linkTitle}
						</Button>
						{!!footerText && (
							<div
								className={styles.footertext}
								// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
								dangerouslySetInnerHTML={{
									__html: footerText,
								}}
							/>
						)}
					</div>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionTextOnlySignpostCard;
